export default __webpack_public_path__ + "static/media/cylinder.436fda30.svg";